<template>
  <div class="mainContainer">
    <!-- <Navbar></Navbar> -->
    <DetailPage
      v-for="item in content"
      :content="item"
      @change="change"
      :type="type"
      :data="form"
    />
    <div class="flex-between footer">
      <div>小计：{{ purchaseAmount }}</div>
      <van-button type="info" @click="modifyConfirm">确定</van-button>
    </div>
  </div>
</template>
<script>
import DetailPage from "@/components/detailPage";
import { get } from "../../../service/api/product";
// import Navbar from "../../components/navbar.vue";

export default {
  name: "index",
  components: { DetailPage },
  data() {
    return {
      form: {
        categoryName: "",
        externalCode: "",
        productPurchasePrice: "",
        retailPrice: "",
        stockNum: "",
        purchaseNum: "",
        purchasePrice: "",
        shelfLife: "",
        shelfLifeDays: "",
      },
      purchaseAmount: 0,
      type: "",
      content: [
        {
          title: "商品信息",
          rows: [
            {
              label: "商品名称",
              key: "productName",
              editable: false,
            },
            {
              label: "商品条码",
              key: "externalCode",
              editable: false,
            },
            {
              label: "采购价",
              key: "productPurchasePrice",
              editable: false,
            },
            {
              label: "零售价",
              key: "retailPrice",
              editable: false,
            },
          ],
        },
        {
          title: "库存信息",
          rows: [
            {
              label: "当前库存",
              key: "stockNum",
              editable: false,
            },
          ],
        },
        {
          title: "退货信息",
          rows: [
            {
              label: "收货数量",
              key: "receiveNum",
              editable: false,
            },
            {
              label: "退货数量",
              key: "returnNum",
              editable: true,
              type:'number'
            },
            {
              label: "采购单价",
              key: "purchasePrice",
              editable: false,
            },
          ],
        },
      ],
      orderingKey: "",
      ordering: {},
    };
  },
  created() {},
  watch: {
    form(newVal) {
      const key = "returnNum";
      this.purchaseAmount = this.$utils.mul(newVal[key], newVal.purchasePrice);
    },
  },
  mounted() {
    this.type = this.$route.query && this.$route.query.type;
    this.getInfo();
  },
  methods: {
    change(newVal) {
      this.form = Object.assign({}, this.form, newVal);
    },
    async getInfo() {
      const id = this.$route.params.id;
      let data = [];
      this.ordering = JSON.parse(
        localStorage.getItem("purchaseReturning") || "{}"
      );
      if (this.ordering.tableData && this.ordering.tableData.length > 0) {
        data = this.ordering.tableData;
      }
      if (data && data.length > 0) {
        this.form = data.filter((el) => el.productId == id)[0];
        
        return;
      }
      const res = await get(id);
      this.form = { ...res.data, available: res.data.available ? "1" : "0" };
    },
    toAnalysis(id) {
      this.$router.push("/analysis/product", { id });
    },
    modifyConfirm() {
      if (this.type === "edit") {
        this.ordering.tableData = this.ordering.tableData.map((el) => {
          if (el.productId === this.form.productId) {
            el = Object.assign(el, this.form);
          }
          return el;
        });
        localStorage.setItem(
          "purchaseReturning",
          JSON.stringify(this.ordering)
        );
      }
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.footer {
  padding: 5px 10px;
  background-color: #fff;
  align-items: center;
  font-size: 16px;
}
</style>
